var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChimney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 32H32C14.326 32 0 46.326 0 64V128C0 145.672 14.326 160 32 160V472C32 476.422 35.578 480 40 480S48 476.422 48 472V384H304V472C304 476.422 307.578 480 312 480S320 476.422 320 472V384H400V472C400 476.422 403.578 480 408 480S416 476.422 416 472V160C433.674 160 448 145.672 448 128V64C448 46.326 433.674 32 416 32ZM128 256H48V160H128V256ZM48 368V272H208V368H48ZM224 368V272H400V368H224ZM400 256H144V160H400V256ZM432 128C432 136.822 424.822 144 416 144H32C23.178 144 16 136.822 16 128V64C16 55.178 23.178 48 32 48H416C424.822 48 432 55.178 432 64V128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChimney);
export default __webpack_public_path__ + "static/media/chimney.cfb9767a7060cfbb10787357615b845a.svg";
export { ForwardRef as ReactComponent };